/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Reactivate_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Reactivate this Space?" |
*
* @param {Spaces_Reactivate_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_reactivate_confirm_title = /** @type {((inputs?: Spaces_Reactivate_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Reactivate_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Space reaktivieren?")
	return /** @type {LocalizedString} */ ("Reactivate this Space?")
});